import { render, staticRenderFns } from "./popup-set-options.vue?vue&type=template&id=5b66c0a6&scoped=true"
import script from "./popup-set-options.vue?vue&type=script&lang=js"
export * from "./popup-set-options.vue?vue&type=script&lang=js"
import style0 from "./popup-set-options.vue?vue&type=style&index=0&id=5b66c0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66c0a6",
  null
  
)

export default component.exports